import { createMutationHook, createQueryHook } from "../factory";

export const aprDrgKeys = {
  all: ["aprDrg"] as const,
  claimStatuses: (input: { claimIds: string[] }) =>
    [...aprDrgKeys.all, "claimStatuses", input] as const,
};

export const aprDrg = {
  drgEnqueueReview: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.aprDrg.drgEnqueueReview,
    mutationKey: ["aprDrg", "drgEnqueueReview"],
  }),
  drgClaimStatuses: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.aprDrg.drgClaimStatuses,
    queryKeyFn: aprDrgKeys.claimStatuses,
  }),
};
